import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const SortAsc: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" {...props}>
        <path
            d="m18 3c0.5523 0 1 0.44772 1 1v16c0 0.5523-0.4477 1-1 1s-1-0.4477-1-1v-16c0-0.55228 0.4477-1 1-1z"
            clipRule="evenodd"
            fill="inherit"
            fillRule="evenodd"
        />
        <path
            d="m17.553 2.1056c0.2815-0.14076 0.6129-0.14076 0.8944 0l4 2c0.494 0.24699 0.6942 0.84767 0.4472 1.3416-0.247 0.49398-0.8476 0.69421-1.3416 0.44722l-3.5528-1.7764-3.5528 1.7764c-0.494 0.24699-1.0946 0.04676-1.3416-0.44722-0.247-0.49397-0.0468-1.0946 0.4472-1.3416l4-2z"
            clipRule="evenodd"
            fill="inherit"
            fillRule="evenodd"
        />
        <rect x="2" y="7" width="7" height="2" rx="1" fill="inherit" />
        <rect x="2" y="11" width="9" height="2" rx="1" fill="inherit" />
        <rect x="2" y="15" width="11" height="2" rx="1" fill="inherit" />
        <rect x="2" y="19" width="13" height="2" rx="1" fill="inherit" />
    </Icon>
);
